import { useAuth } from "../context/AuthContext";
import HomePage from "../ecommerce/pages/homepage/HomePage";
import EcommLandingPage from "../ecommerce/pages/EcommLandingPage/EcommLandingPage";

const RootRoute = () => {
  const { isAuthenticated, profileLoading } = useAuth();

  if (profileLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-dark" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <HomePage /> : <EcommLandingPage />;
};

export default RootRoute;
